/**
 * Model to map executive summary.
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class ExecutiveSummary {
    introduction: string;
    initialContact: string;
    purpose: string;
    originOfFunds: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/executive-summary.model.ts